import { useContext, useEffect } from "react";

import AuthContext from "context/auth/authContext";
import { useSignalRForNotifications } from "context/signalR/hooks/useSignalRForNotifications";

import NotificationsContext from "../notificationsContext";

const useReceiveNotifications = () => {
    const { user } = useContext(AuthContext);
    const { setNotificationsCount } = useContext(NotificationsContext);

    useSignalRForNotifications(user?.id, () => setNotificationsCount());

    useEffect(() => {
        setNotificationsCount();
        // eslint-disable-next-line
    }, []);
};

export { useReceiveNotifications };
